import { Config } from '../../config/config';
import { Data } from './data';
import { Img } from './img';

export class Critere extends Data {

    label: string;
    type_critere: string;
    description;
    short_description;
    photo: Img;

    constructor() {
        super();
    }


    get urltmbPhoto(): string {

        if( this.photo !== undefined && this.photo !== null && this.photo.url !== null)
        return  Config.urlserveur + this.photo.url; // return  Config.urlserveur + this.photo.tmb;
        else
        return 'assets/images/noimage.png';
    }

    
    
   
  }